import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin } from 'lucide-react';

const cities = [
    { name: "Dallas, TX", id: "dallas-tx" },
    { name: "Miami, FL", id: "miami-fl" },
    { name: "Denver, CO", id: "denver-co" },
    { name: "Atlanta, GA", id: "atlanta-ga" },
    { name: "Chicago, IL", id: "chicago-il" },
    { name: "Charlotte, NC", id: "charlotte-nc" },
    { name: "Austin, TX", id: "austin-tx" },
    { name: "Phoenix, AZ", id: "phoenix-az" }
];

const Footer = () => {
    return (
        <footer className="bg-[#0A0A14] pt-24 pb-12 px-6 md:px-16 rounded-t-[4rem] relative z-50 text-[#F0EFF4] border-t border-[#F0EFF4]/5 mt-20">
            <div className="max-w-7xl mx-auto flex flex-col lg:flex-row gap-16 lg:gap-8 mb-20 justify-between">

                {/* Brand & Status Column */}
                <div className="flex flex-col items-start lg:w-1/4">
                    <h2 className="font-bold text-3xl tracking-tight mb-4">RoofClaw</h2>
                    <p className="text-[#F0EFF4]/40 leading-relaxed mb-8 pr-4">
                        One step to a completely safe, secure, and stable OpenClaw configured, physical AI agent delivered to your door.
                    </p>

                    <div className="flex items-center gap-3 bg-[#18181B] px-4 py-2 rounded-full border border-[#F0EFF4]/10 shadow-sm">
                        <span className="w-2 h-2 rounded-full bg-[#10B981] animate-pulse"></span>
                        <span className="font-data text-xs text-[#10B981] font-bold">SYSTEM OPERATIONAL</span>
                    </div>
                </div>

                {/* Sitemap Columns */}
                <div className="grid grid-cols-2 lg:grid-cols-4 gap-x-8 gap-y-12 lg:w-3/4">

                    {/* Column 1: The System */}
                    <div className="flex flex-col gap-4">
                        <h4 className="font-semibold text-[#F0EFF4] mb-2 font-data text-xs tracking-widest uppercase">The System</h4>
                        <Link to="/product" className="text-[#F0EFF4]/40 hover:text-[#7B61FF] transition-colors text-sm">Architecture</Link>
                        <Link to="/hardware" className="text-[#F0EFF4]/40 hover:text-[#7B61FF] transition-colors text-sm">Hardware Specs</Link>
                        <Link to="/use-cases" className="text-[#F0EFF4]/40 hover:text-[#7B61FF] transition-colors text-sm">Use Cases</Link>
                        <Link to="/process" className="text-[#F0EFF4]/40 hover:text-[#7B61FF] transition-colors text-sm">Deployment Process</Link>
                        <Link to="/why" className="text-[#F0EFF4]/40 hover:text-[#7B61FF] transition-colors text-sm">Why Buy vs Build</Link>
                    </div>

                    {/* Column 2: Resources */}
                    <div className="flex flex-col gap-4">
                        <h4 className="font-semibold text-[#F0EFF4] mb-2 font-data text-xs tracking-widest uppercase">Resources</h4>
                        <Link to="/blog" className="text-[#F0EFF4]/40 hover:text-[#7B61FF] transition-colors text-sm font-semibold text-[#7B61FF]/70 flex items-center gap-2">Intelligence (Blog)</Link>
                        <a href="/2027-website-design" className="text-[#F0EFF4]/40 hover:text-[#7B61FF] transition-colors text-sm">Sparkitecture: Websites That Do Something</a>
                        <Link to="/faq" className="text-[#F0EFF4]/40 hover:text-[#7B61FF] transition-colors text-sm">FAQ</Link>
                        <a href="https://roofingbusinesspartner.com" target="_blank" rel="noopener noreferrer" className="text-[#F0EFF4]/40 hover:text-[#7B61FF] transition-colors text-sm">Roofing Business Partner</a>
                        <Link to="/winning-wednesday" className="text-[#F0EFF4]/40 hover:text-[#7B61FF] transition-colors text-sm">Winning Wednesday (Free Support)</Link>
                    </div>

                    {/* Column 3: Locations */}
                    <div className="flex flex-col gap-4 col-span-2 sm:col-span-1">
                        <div className="flex items-center gap-2 mb-2">
                            <MapPin className="w-4 h-4 text-[#7B61FF]" />
                            <h4 className="font-semibold text-[#F0EFF4] font-data text-xs tracking-widest uppercase">Deployed Markets</h4>
                        </div>
                        <ul className="grid grid-cols-2 gap-x-4 gap-y-3">
                            {cities.map(city => (
                                <li key={city.id}>
                                    <Link to={`/locations/${city.id}`} className="text-[#F0EFF4]/40 hover:text-[#7B61FF] transition-colors text-sm select-none">
                                        {city.name}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>

            {/* Bottom Bar */}
            <div className="max-w-7xl mx-auto pt-8 border-t border-[#F0EFF4]/10 flex flex-col md:flex-row justify-between items-center gap-6 text-xs text-[#F0EFF4]/30">
                <p>&copy; {new Date().getFullYear()} RoofClaw Systems. All rights reserved.</p>
                <div className="flex items-center gap-6 shadow-sm">
                    <Link to="/privacy" className="hover:text-[#F0EFF4] transition-colors">Privacy</Link>
                    <Link to="/terms" className="hover:text-[#F0EFF4] transition-colors">Terms</Link>
                    <p className="font-data tracking-widest text-[#7B61FF]/50 border-l border-[#F0EFF4]/10 pl-6 ml-2">BUILD: V1.1.0-RC</p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
